if(!customElements.get('slide-gallery')){
    class SlideGallery extends HTMLElement {
        constructor(){
            super();

            this.swiperEl = this.querySelector('.swiper');
            this.config = JSON.parse(this.querySelector('script').textContent);

            this.swiper = new Swiper(this.swiperEl, this.config);
        }
    }

    customElements.define('slide-gallery', SlideGallery);
}